import { Component } from '@angular/core';

@Component({
    selector: 'no-connection',
    templateUrl: 'no-connection.html',
})
export class NoConnectionComponent {

}



// WEBPACK FOOTER //
// ./src/components/no-connection/no-connection.ts